import React, { useEffect, useState } from "react";
import ContactFormDisplay from "./ContactFormDisplay";
import { useUser } from "./../../../../contexts/UserContext";
import useScrollToTop from "./../../../../hooks/useScrollToTop";
import { ToastContainer, toast } from "react-toastify";
import { FaEnvelopeOpenText, FaLock, FaInbox } from "react-icons/fa";

const HERO =
  "relative overflow-hidden rounded-[30px] bg-slate-950 text-white border border-slate-800 shadow-[0_25px_70px_-25px_rgba(15,23,42,0.85)]";

export default function ContactForm() {
  useScrollToTop();
  const { user } = useUser();
  const [userId, setUserId] = useState(null);

  const getUserIdFromLocalStorage = () => {
    try {
      const userData = localStorage.getItem("userInfo");
      if (userData) {
        const userObj = JSON.parse(userData);
        return userObj.userId;
      }
    } catch (error) {
      console.error(
        "Erreur lors de la lecture des données de l'utilisateur:",
        error
      );
      toast.error("Erreur lors de la lecture des données de l'utilisateur.");
    }
    return null;
  };

  useEffect(() => {
    const id = user?.userId || getUserIdFromLocalStorage();
    if (!id) {
      console.error("L'ID de l'utilisateur n'est pas trouvé");
      toast.error("L'ID de l'utilisateur n'est pas trouvé.");
    } else {
      setUserId(id);
    }
  }, [user]);

  if (!userId) {
    return (
      <div className="min-h-[50vh] grid place-items-center px-4">
        <div className="w-full max-w-lg rounded-[28px] border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-8 shadow-[0_18px_50px_-20px_rgba(15,23,42,0.28)] text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-3xl bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200">
            <FaLock className="text-2xl" />
          </div>
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-50">
            Accès sécurisé
          </h2>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
            Vous devez être connecté pour accéder à l’espace de gestion des
            messages du formulaire de contact.
          </p>
        </div>
      </div>
    );
  }

  if (user?.role_id !== 1) {
    return (
      <div className="min-h-[50vh] grid place-items-center px-4">
        <div className="w-full max-w-lg rounded-[28px] border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-8 shadow-[0_18px_50px_-20px_rgba(15,23,42,0.28)] text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-3xl bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200">
            <FaInbox className="text-2xl" />
          </div>
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-50">
            Accès réservé à l’administration
          </h2>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
            Cette page est réservée aux administrateurs pour la gestion des
            messages entrants.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-4 lg:p-6">
      <section className={HERO}>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(129,140,248,0.35),transparent_30%),radial-gradient(circle_at_top_right,rgba(236,72,153,0.30),transparent_25%),radial-gradient(circle_at_bottom_left,rgba(34,197,94,0.16),transparent_30%)]" />
        <div className="relative p-6 md:p-8">
          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-white/80">
              <FaEnvelopeOpenText />
              Support & demandes entrantes
            </div>

            <h1 className="mt-4 text-3xl font-semibold tracking-tight md:text-4xl">
              Messages du formulaire de contact
            </h1>

            <p className="mt-3 max-w-2xl text-sm leading-6 text-white/75 md:text-base">
              Retrouvez ici tous les messages reçus depuis le formulaire de
              contact, filtrez rapidement les non lus et traitez vos demandes
              depuis une interface plus claire.
            </p>
          </div>
        </div>
      </section>

      <ContactFormDisplay userId={userId} />

      <ToastContainer />
    </div>
  );
}